import React from "react";

import { CheckIcon } from "@/Components/Icons/CheckIcon";
import { sessionTypeList } from "@/Constants/filterConstants";

/**
 * Function for rendering a session type filter component.
 *
 * @param {Object} active - the currently active session type
 * @param {Function} handleClick - function to handle click events
 * @return {JSX.Element} a React component for session type filtering
 */
const SessionTypeFilter = ({ active, handleClick }) => {
  const handleItemClick = (value) => {
    handleClick(
      active.includes(value)
        ? active.filter((item) => item !== value)
        : [...active, value],
    );
  };

  return (
    <div className="SessionTypeFilter_Wrapper">
      <div className="grid gap-3">
        <label className="label text-black" htmlFor="sessionType">
          Session Type
        </label>
        <div className="flex gap-4">
          {sessionTypeList.map((item, index) => {
            return (
              <div
                key={index}
                className={`ease flex cursor-pointer items-center gap-2 rounded-lg py-2 transition-all duration-300 ${
                  active.includes(item.value)
                    ? "bg-primary px-[0.60rem] text-white"
                    : "bg-grey px-[1.03rem] text-txtColor hover:bg-lightblue"
                }`}
                onClick={() => {
                  handleItemClick(item.value);
                }}
              >
                <span
                  className={`block overflow-hidden !text-white transition-all duration-300 ${
                    active.includes(item.value) ? "w-[14px]" : "w-0"
                  }`}
                >
                  <CheckIcon />
                </span>
                <span
                  className="whitespace-nowrap text-[14px]"
                  htmlFor="candidateType"
                >
                  {item.name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SessionTypeFilter;
